export const openInPopup = (url: string) => {
  const width = 1100;
  const height = 756;
  const left = window.innerWidth / 2 - width / 2;
  const top = window.innerHeight / 2 - height / 2;

  window.open(
    url,
    '_blank',
    `width=${width},height=${height},top=${top},left=${left},location=yes,menubar=no,toolbar=no`
  );
};
